import { render, staticRenderFns } from "./wapHead.vue?vue&type=template&id=489ae5ea"
import script from "./wapHead.vue?vue&type=script&lang=js"
export * from "./wapHead.vue?vue&type=script&lang=js"
import style0 from "./wapHead.vue?vue&type=style&index=0&id=489ae5ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports